import React, { useState } from "react";
import { X } from "lucide-react";
import { toast } from "react-toastify";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import SelectDropdown from "../../customStyles/SelectDropdown";

export default function CaseCategoryDrawer({ isOpen, onClose, onSuccess }) {
  const [newCategory, setNewCategory] = useState({
    name: "",
    description: "",
    defaultAssigneeRole: "reporting_manager"
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newCategory.name.trim()) {
      toast.error("Category name is required");
      return;
    }

    setSubmitting(true);
    try {
      const url = SummaryApi.createCaseCategory?.url || "/api/case-categories/create";
      const res = await api.post(url, newCategory);
      
      if (res.data.success) {
        toast.success("Case Category created successfully.");
        // Form-ஐ ரீசெட் செய்தல்
        setNewCategory({ name: "", description: "", defaultAssigneeRole: "reporting_manager" });
        onSuccess(); // பட்டியலை ரிஃப்ரெஷ் செய்ய callback
        onClose(); // டிராயரை மூட
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to create category.");
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Background Overlay */}
      <div 
        onClick={onClose}
        className="fixed inset-0 top-[57px] md:top-[65px] z-[65] bg-black/40 backdrop-blur-xs transition-opacity duration-300"
      />

      {/* Slide Drawer */}
      <div className="fixed inset-y-0 top-[57px] md:top-[65px] right-0 z-[65] w-full max-w-md bg-white border-l shadow-2xl flex flex-col transition-transform duration-300 ease-in-out transform translate-x-0">
        <div className="p-4 border-b flex justify-between items-center bg-slate-50 shrink-0">
          <div className="text-left">
            <h3 className="font-bold text-slate-900 text-sm">Add New Case Category</h3>
            <p className="text-[10px] text-slate-400">Define routing parameters and default routing targets</p>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-slate-200 rounded-lg transition-colors border">
            <X className="w-4 h-4 text-slate-500" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-5 flex-1 overflow-y-auto space-y-4 text-left text-xs">
          <div className="space-y-1">
            <label className="font-bold text-slate-500 block">Category Name *</label>
            <input 
              type="text" 
              required
              value={newCategory.name}
              onChange={e => setNewCategory({ ...newCategory, name: e.target.value })}
              placeholder="E.g., IT Security incidents, Harassment"
              className="w-full border border-slate-200 rounded-lg p-2 outline-none focus:border-red-400"
            />
          </div>

          <div className="space-y-1">
            <label className="font-bold text-slate-500 block">Default Assignee Routing Rule</label>
            <SelectDropdown 
              options={[
                { label: "Direct Reporting Manager", value: "reporting_manager" },
                { label: "Human Resources", value: "hr" },
                { label: "IT Administration Desk", value: "it_admin" }
              ]} 
              value={newCategory.defaultAssigneeRole} 
              onChange={val => setNewCategory({ ...newCategory, defaultAssigneeRole: val })} 
              placeholder="Choose assignee role" 
              valueKey="value" 
              labelKey="label" 
              ChildClassName="h-9 border-slate-200 focus:border-red-400" 
              zIndex={66}
            />
          </div>

          <div className="space-y-1">
            <label className="font-bold text-slate-500 block">Brief Description</label>
            <textarea 
              rows={3}
              value={newCategory.description}
              onChange={e => setNewCategory({ ...newCategory, description: e.target.value })}
              placeholder="Brief summary explaining what cases fall under this category..."
              className="w-full border border-slate-200 rounded-lg p-2 outline-none focus:border-red-400"
            />
          </div>

          <div className="pt-4 flex gap-2">
            <button 
              type="submit" 
              disabled={submitting}
              className="flex-1 py-2 bg-red-600 hover:bg-red-700 disabled:bg-slate-400 text-white font-bold rounded-lg transition-colors shadow"
            >
              {submitting ? "Saving..." : "Save Category"}
            </button>
            <button 
              type="button" 
              onClick={onClose} 
              className="px-4 py-2 border rounded-lg text-slate-500 hover:bg-slate-50 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
}